import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogBody, DialogFooter, DialogDescription } from '../../../ui/dialog';
import { Button } from '../../../ui/button';
import { Checkbox } from '../../../ui/checkbox';
import { Mail, CheckCircle2 } from 'lucide-react';
import { LOCATION_BREAKDOWN } from '../../fixtures';

const SendRemindersDialog = ({ open, onOpenChange }) => {
  const [sent, setSent] = useState(false);
  const [selected, setSelected] = useState(() =>
    LOCATION_BREAKDOWN.reduce((acc, l) => ({ ...acc, [l.location]: true }), {}),
  );
  const outstanding = LOCATION_BREAKDOWN.reduce(
    (sum, l) => (selected[l.location] ? sum + (l.fte - l.respondents) : sum),
    0,
  );

  const send = () => {
    setTimeout(() => setSent(true), 700);
    setTimeout(() => {
      onOpenChange(false);
      setSent(false);
    }, 2400);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='max-w-md' onClose={() => onOpenChange(false)}>
        <DialogHeader>
          <DialogTitle>Send reminders</DialogTitle>
          <DialogDescription>Choose which locations to nudge.</DialogDescription>
        </DialogHeader>

        <DialogBody>
          {sent ? (
            <div className='flex flex-col items-center py-6 text-center'>
              <div className='w-12 h-12 rounded-full bg-success-bg flex items-center justify-center text-success mb-4'>
                <CheckCircle2 size={20} strokeWidth={1.5} />
              </div>
              <div className='font-medium mb-1'>Reminders sent</div>
              <div className='text-xs text-muted-foreground'>
                Outstanding employees in the selected locations will receive a reminder email.
              </div>
            </div>
          ) : (
            <div className='space-y-3'>
              {LOCATION_BREAKDOWN.map((row) => {
                const out = row.fte - row.respondents;
                return (
                  <label
                    key={row.location}
                    className='flex items-start gap-3 rounded-lg border border-border p-3 cursor-pointer hover:border-primary transition-colors'>
                    <Checkbox
                      checked={!!selected[row.location]}
                      onCheckedChange={(v) =>
                        setSelected((prev) => ({ ...prev, [row.location]: !!v }))
                      }
                    />
                    <div className='flex-1'>
                      <div className='flex items-center justify-between'>
                        <div className='font-medium text-sm'>{row.location}</div>
                        <div className='font-mono text-xs text-muted-foreground'>
                          {out} outstanding
                        </div>
                      </div>
                      <div className='text-xs text-muted-foreground'>
                        {row.respondents} of {row.fte} FTE responded
                      </div>
                    </div>
                  </label>
                );
              })}
            </div>
          )}
        </DialogBody>

        {!sent && (
          <DialogFooter>
            <Button variant='ghost' onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={send} disabled={outstanding === 0}>
              <Mail size={14} strokeWidth={1.5} />
              Remind {outstanding} employees
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SendRemindersDialog;
